export * from './prizmIcons-magnifying-glass.icon';
